import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const deleteProgramCountryNominationReviewer: (
  fetchContext: FetchContext,
  programCountryNominationReviewerId: number,
  accessToken?: string,
) => Promise<void> = (fetchContext, programCountryNominationReviewerId, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/program-country-nomination-reviewers/${programCountryNominationReviewerId}`,
  {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'delete program country nomination reviewer'));
